import React from 'react'

const ContentProgressBar: React.FC<{
  scrollPercent?: string
  current?: number
  total?: number
}> = ({ scrollPercent, current, total }) => {
  const displayText = typeof current === 'number' && typeof total === 'number';
  let width = scrollPercent

  if (displayText) {
    width = `${Math.min(100, (current / total) * 100)}%`
  }

  return (
    <div className="content-progress-bar">
      {displayText && <p className="content-progress-bar__text">
        Showing <strong>{current}</strong> out of <strong>{total}</strong>{' '}
        posts
      </p>}
      <div className="content-progress-bar__outer">
        <div className="content-progress-bar__inner" style={{ width }} />
      </div>
    </div>
  )
}

export default ContentProgressBar
